import React, { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateBuilderLinks } from "../../../../redux/slices/linksBuilder";
import AddImgToLink from "./AddImgToLink";
import { Col, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { TrashIcon } from "../svg";
import Form from "react-bootstrap/Form";
import InputText from "../../../../components/input/inputText";
import {
  validLinkPattern,
  validLinkProtocol,
} from "../../../../RegExpValidations";
import { isValidLinkString } from "../../../../hooks/helpers";
import classNames from "classnames";

const LINK_LENGTH = 2000;

export default memo(function AddLinkItem({ error, handleLinkValidate }) {
  const { lang, data } = useSelector((state) => ({
    lang: state.changeLang.language.stepTwo.linkList || [],
    data: state.linksBuilder.data,
  }));

  const dispatch = useDispatch();

  const handleDeleteLink = (id) => {
    dispatch(updateBuilderLinks(data.links.filter((item) => item.id !== id)));
  };

  const handleChangeText = (id, value) => {
    const updateData = data.links.map((item) =>
      item.id === id ? { ...item, text: value } : item
    );
    dispatch(updateBuilderLinks(updateData));
  };

  const handleChangeUrl = (id, value) => {
    let string = value.trim();
    const validate = validLinkPattern.test(string);
    const validateProtocol = validLinkProtocol.test(string);
    if (validate) {
      handleLinkValidate(!validate || string.length > LINK_LENGTH);
      if (!/^.+:\/\//.test(string)) {
        string = `http://${string}`;
      }
    } else if (validateProtocol && !string.startsWith("http")) {
      handleLinkValidate(!validateProtocol || string.length > LINK_LENGTH);
    }
    const updateData = data.links.map((item) =>
      item.id === id ? { ...item, url: string } : item
    );
    dispatch(updateBuilderLinks(updateData));
  };

  return (
    <>
      {data.links.map((item, index) => (
        <div key={item.id} className="mb-4">
          <Row className="justify-content-between align-content-center fs-5 text-bold mb-3">
            <Col xs="auto">
              <div>
                {lang[13]} {index + 1}
              </div>
            </Col>
            <Col xs="auto">
              <Button
                variant="link"
                className="text-primary p-0"
                onClick={() => handleDeleteLink(item.id)}
              >
                <TrashIcon />
              </Button>
            </Col>
          </Row>

          <AddImgToLink linkItem={item} />

          <InputText
            placeholder={lang[18]}
            type="text"
            name="link"
            value={item.url}
            onChange={(e) => handleChangeUrl(item.id, e.target.value)}
            className={classNames("mb-3", {
              "error-field": !isValidLinkString(item.url),
            })}
            error={
              item.url.length > 2 &&
              (!item.url.trim() ||
                item.url.length > LINK_LENGTH ||
                !isValidLinkString(item.url))
            }
            valid={
              isValidLinkString(item.url) &&
              item.url.length > 2 &&
              item.url.length <= LINK_LENGTH
            }
            popoverText={null}
          >
            {error && !item.url.trim() && (
              <Form.Text className="text-danger">{lang[20]}</Form.Text>
            )}
            {error && item.url.length > LINK_LENGTH && (
              <Form.Text className="text-danger">{lang[25]}</Form.Text>
            )}
            {item.url.length > 3 && !isValidLinkString(item.url) && (
              <Form.Text className="text-danger">
                {lang[18]}: https://me-qr.com/
              </Form.Text>
            )}
          </InputText>

          <InputText
            placeholder={lang[30]}
            type="text"
            name="linkTitle"
            value={item.text}
            onChange={(e) => handleChangeText(item.id, e.target.value)}
            popoverText={null}
            error={error && !item.text.trim()}
            valid={item.text.length}
            maxLength={255}
          >
            {error && !item.text.trim() && (
              <Form.Text className="text-danger">{lang[20]}</Form.Text>
            )}
          </InputText>
        </div>
      ))}
    </>
  );
});
